import { createFileRoute } from "@tanstack/react-router";
import { AccessReceivedPage } from "@/features/auth/access-received-page";

/** "Thanks, we'll contact you" after an access request (ALP-85). */
export const Route = createFileRoute("/signup/received")({
  head: () => ({ meta: [{ title: "Request received · Malfak" }] }),
  component: AccessReceivedPage,
});
